export default {
	addModal: 'ADD_MODAL',
	removeModal: 'REMOVE_MODAL',
};
